import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { Row } from '~/modules/coreUI/components/legacies/Rows';
import { mediaQueryMin } from '~/modules/core/utils/cssHelpers/cssMedia';
import { LargeSpacer, XLargeSpacer } from '~/modules/coreUI/components/legacies/Spacers';
import withRefetchConsumer from '~/modules/core/utils/relayHelpers/withRefetchConsumer';
import EmptyResultPage from '~/modules/ecommerceCoreUI/components/listViewLayout/EmptyResultPage';

import ItemsListFilter from './ItemsListFilter';
import ItemsListSection from './ItemsListSection';

const isAnyFilterSelected = refetchVariables => refetchVariables
  && refetchVariables.input
  && refetchVariables.input.filter
  && refetchVariables.input.filter.length > 0;

const ListViewLayout = ({
  itemsList,
  categoryID,
  pinnedProducts,
  showCardViewChangers,
  banner,
  isLoading,
  isVariant,
  isProduct,
  changeView,
  isVertical,
  showFilterList,
  showFilterDropdown,
  searchString,
  refetchVariables,
  vendorInfo,
  isVendorProduct,
  categorizeItemsList,
}) => {
  const changeCardsView = (value) => {
    changeView(value);
  };
  return (
    <React.Fragment>
      {isLoading || itemsList?.length !== 0 || categorizeItemsList?.length !== 0 || isAnyFilterSelected(refetchVariables) ? (
        <React.Fragment>
          {banner && (
            <React.Fragment>
              {banner}
              <XLargeSpacer />
            </React.Fragment>
          )}
          <React.Fragment>
            <div className="PaginatedListContainer">
              <Row justifyStart topAligned>
                {showFilterList && (
                  <Media query={mediaQueryMin('desktop')}>
                    {matches => matches && (
                    <React.Fragment>
                      <ItemsListFilter />
                      <LargeSpacer />
                    </React.Fragment>
                    )
                    }
                  </Media>
                )}
                <ItemsListSection
                  isProduct={isProduct}
                  isVariant={isVariant}
                  isLoading={isLoading}
                  categoryID={categoryID}
                  itemsList={itemsList}
                  isVendorProduct={isVendorProduct}
                  pinnedProducts={pinnedProducts}
                  showCardViewChangers={showCardViewChangers}
                  changeView={changeCardsView}
                  isVertical={isVertical}
                  showFilterDropdown={showFilterDropdown}
                  vendorInfo={vendorInfo}
                  categorizeItemsList={categorizeItemsList}
                />
              </Row>
            </div>
            <XLargeSpacer />
          </React.Fragment>
        </React.Fragment>
      ) : (
        <EmptyResultPage isProduct={isProduct || isVariant} searchString={searchString} />
      )}
    </React.Fragment>
  );
};

ListViewLayout.propTypes = {
  itemsList: PropTypes.arrayOf(PropTypes.shape({})),
  categorizeItemsList: PropTypes.arrayOf(PropTypes.shape({})),
  refetchVariables: PropTypes.shape({}).isRequired,
  categoryID: PropTypes.string,
  pinnedProducts: PropTypes.element,
  showCardViewChangers: PropTypes.bool,
  banner: PropTypes.objectOf(PropTypes.any),
  isProduct: PropTypes.bool,
  isVariant: PropTypes.bool,
  isLoading: PropTypes.bool.isRequired,
  changeView: PropTypes.func,
  isVertical: PropTypes.bool,
  showFilterList: PropTypes.bool,
  showFilterDropdown: PropTypes.bool,
  searchString: PropTypes.string,
  isVendorProduct: PropTypes.bool,
  vendorInfo: PropTypes.shape({
    vendorID: PropTypes.string,
    vendorName: PropTypes.string,
  }),
};

ListViewLayout.defaultProps = {
  changeView: null,
  pinnedProducts: null,
  showCardViewChangers: false,
  banner: null,
  isProduct: false,
  isVariant: false,
  showFilterList: false,
  isVertical: true,
  showFilterDropdown: false,
  categoryID: null,
  searchString: null,
  isVendorProduct: false,
  vendorInfo: {},
  categorizeItemsList: null,
  itemsList: null,
};
export default withRefetchConsumer(ListViewLayout);
